<template>
  <div id="HomePage">
    <div class="nav-bar"></div>

    <!-- 第一板块 -->
    <el-row class="banner-row" type="flex" justify="center">
      <el-col :lg="16" :xs="24" :sm="22" :md="18" class="banner-col">
        <!-- 问答详情 -->
        <div class="banner-col-left">
          <router-view />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import { home, changebatch } from "@/api/home";

export default {
  name: "HomePage",
  data() {
    return {
      page: 1,

      search_words: "",
      search_list: [],

      list: [],

      activeIndex: 0,

      show_detail: false,

      // 标签栏
      nav_list: [
        {
          title: "留学研究所",
          children: []
        },
        {
          title: "留学那些年",
          children: []
        },
        {
          title: "前沿洞见",
          children: []
        },
        {
          title: "集结号",
          children: []
        }
      ],

      // 首页数据
      homeData: [],

      // 轮播图列表
      carousel_list: [],

      // 文章列表
      article_list: [],

      // 推荐列表
      recod_list: [],
      is_more: true
    };
  },
  created() {
    if (document.documentElement.clientWidth <= 768) {
    }
  },
  mounted() {
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      duration: "5s",
      mobile: true,
      live: true
    });
    wow.init();
  },
  watch: {
    $route(to) {
      if (to.name === "institute_detail") this.show_detail = true;
      else this.show_detail = false;
    }
  },
  computed: {
    // list () {
    //   return this.recod_list.map((item, index) => {
    //     item.create_time = dateUtils.GetNowTime(item.create_time)
    //     console.log(item.create_time);
    //     return item
    //   })
    // }
  },
  methods: {
    // 首页初始化数据
    async home() {
      const { data: res } = await home();
      // console.log('首页', res.data);
      this.homeData = res.data;
      res.data.forEach(item => {
        if (item.title === "为你推荐") this.article_list = item.article_list;
      });
    },

    // 进入研究所详情
    toQaDetail(item) {
      if (!this.show_detail) {
        this.$router.push({
          name: "institute_detail",
          query: {
            id: item.id
          }
        });
      } else {
        this.$store.commit("changeInstituteId", item.id);
      }
    },

    // 换一批
    async changebatch(type) {
      let id;
      this.homeData.forEach(item => {
        if (item.title === "为你推荐") id = item.id;
      });
      let data = {
        module_id: id
      };
      const { data: res } = await changebatch(data);
      this.article_list = res.data;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/common.scss";

/* 整体盒子 */
#HomePage {
  width: 100%;
  padding: 0 0 0.7rem;
  background: #f5f6fa;
}

/* 主体 */
.banner-row {
  width: 100%;
  margin-top: 0.4rem;

  .banner-col {
    padding: 0 0.25rem;
    @include flex-line-between;
    align-items: flex-start;
    position: relative;
  }
}

// S-首页左边
.banner-col-left {
  width: 100%;
}

// S-首页右边
.banner-col-right {
  width: 3.16rem;

  // margin-left: 0.3rem;

  .hot-article {
    width: 100%;
    padding: 0.24rem 0.2rem 0;
    background-color: #fff;
    box-shadow: 0px 0.02rem 0.04rem 0px rgba(231, 231, 231, 0.5);
    border-radius: 0.05rem;

    .article-title {
      width: 100%;
      @include flex-line-between;
      font-size: 0.18rem;
      padding-bottom: 0.2rem;
      border-bottom: 1px solid $line-color;

      .change {
        color: #9ea5b8;
        font-size: 0.14rem;
      }
    }

    ul {
      width: 100%;

      li {
        cursor: pointer;
        width: 100%;
        margin-top: 0.2rem;
        padding-bottom: 0.2rem;
        line-height: 0.26rem;
        border-bottom: 1px solid $line-color;
        @include flex-line-start;

        /deep/ .el-image,
        .img {
          width: 0.7rem;
          height: 0.46rem;

          img {
            width: 100%;
            height: 100%;
            border-radius: 0.03rem;
          }
        }

        .word {
          flex: 1;
          height: 0.46rem;
          margin-left: 0.08rem;
          font-size: 0.14rem;
          @include text-ellipse;
          @include flex-colume-between;

          .title {
            width: 100%;
            @include text-ellipse;
          }

          .desc {
            width: 100%;
            color: #666666;
            font-size: 0.12rem;
            @include text-ellipse;
          }
        }
      }

      li:last-of-type {
        border: none;
      }
    }
  }

  .qr {
    padding: 0.2rem;
    font-size: 0.2rem;
    margin-top: 0.24rem;
    background-color: #fff;
    box-shadow: 0px 0.02rem 0.04rem 0px rgba(231, 231, 231, 0.5);
    border-radius: 0.05rem;

    .desc {
      color: $tips-color;
      font-size: 0.14rem;
      margin: 0.08rem 0 0.16rem;
    }

    .img {
      width: 2.75rem;
      height: 2.75rem;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #HomePage {
    width: 100vw;
    background: #fff;
    padding-bottom: 0;

    .banner-col {
      padding: 0 0.3rem;
    }

    // S-首页左边
    .banner-col-left,
    .qa-detail {
      width: 100%;
    }
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #HomePage {
    width: 100%;
    padding-bottom: 0.4rem;

    .banner-col {
      padding: 0;
    }

    // S-首页左边
    .banner-col-left,
    .qa-detail {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/HomePage.vue